import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Edad from "./Edad";
import Piel from "./Piel";
import Bienvenida from "./Bienvenida";
import Objetivo from "./Objetivo";
import EstiloDeVida from "./EstiloDeVida";
import Resultados from "./Resultados";
import validator from "validator";
import { useRef } from "react";
import theme from "./theme";
import idioma_lbl from "./index";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://labelistcosmetics.com/">
        Labelist Cosmetics
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const steps = [
  { name: "Bienvenida", name_en: "Welcome", name_es: "Bienvenida", element: Bienvenida, seq: 0 },
  { name: "Edad", name_en: "Age", name_es: "Edad", element: Edad, seq: 1 },
  { name: "Piel", name_en: "Skin", name_es: "Piel", element: Piel, seq: 2 },
  { name: "Objetivo", name_en: "Desired result", name_es: "Objetivo", element: Objetivo, seq: 3 },
  { name: "Estilo de vida", name_en: "Lifestyle", name_es: "Estilo de vida", element: EstiloDeVida, seq: 4 }
];

export default function Quiz() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [data, setData] = React.useState({});
  const [checkedValuesObj, setCheckedValuesObj] = React.useState([]);
  const windowSize = useRef(window.innerWidth);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  // disable advancing button
  const isAdvanceDisabled = () => {
    if (activeStep === 0) {
      if (data[steps[activeStep].name]) {
        return !validator.isEmail(data[steps[activeStep].name]);
      } else {
        return true;
      }
    } else if (activeStep === 1) {
      return isNaN(+data[steps[activeStep].name]);
    } else if (activeStep === 2) {
      return !data[steps[activeStep].name];
    } else if (activeStep === 3) {
      return checkedValuesObj.length === 0;
    } else {
      return false;
    }
  };

  // onChange data updated
  const updateData = (key) => (e) => {
    let tmpData = { ...data };
    tmpData[key] = e.target.value;
    setData(tmpData);
  };

  const updateObjetivo = (e) => {
    let tmpData = checkedValuesObj?.includes(e.target.value)
      ? checkedValuesObj?.filter((name) => name !== e.target.value)
      : [...(checkedValuesObj ?? []), e.target.value];
    setCheckedValuesObj(tmpData);
  };

  const ActiveElement =
    activeStep < steps.length ? steps[activeStep].element : null;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar
        position="absolute"
        color="default"
        elevation={0}
        sx={{
          position: "relative",
          borderBottom: (t) => `1px solid ${t.palette.divider}`
        }}
      ></AppBar>
      <Container component="main" maxWidth="lg" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <Typography component="h2" variant="h4" align="center">
            {idioma_lbl === "en"
              ? "Discover your personal Labelist beauty routine!"
              : "Descubre la mejor rutina Labelist para ti!"}
          </Typography>
          <Stepper
            orientation={windowSize.current > 600 ? "horizontal" : "vertical"}
            activeStep={activeStep}
            sx={{ pt: 3, pb: 5 }}
          >
            {steps.map((label) => (
              <Step key={label.seq}>
                <StepLabel>{idioma_lbl === "en" ? label.name_en : label.name_es}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Resultados choices={data} purpose={checkedValuesObj} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ActiveElement
                handler_data={updateData(steps[activeStep].name)}
                handler_obj={updateObjetivo}
              />
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                {activeStep !== 0 && (
                  <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                    {idioma_lbl === "en" ? "Back" : "Atrás"}
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={isAdvanceDisabled()}
                  onClick={handleNext}
                  sx={{ mt: 3, ml: 1 }}
                >
                  {idioma_lbl === "en"
                    ? activeStep === 0
                      ? "Start!"
                      : activeStep === steps.length - 1
                      ? "Discover your routine"
                      : "Next"
                    : activeStep === 0
                    ? "Empezamos!"
                    : activeStep === steps.length - 1
                    ? "Descubre tu rutina"
                    : "Siguiente"}
                </Button>
              </Box>
            </React.Fragment>
          )}
        </Paper>
        <Copyright />
      </Container>
    </ThemeProvider>
  );
}
